import groq from 'groq';

export const GIF = groq`
  title,
  "cloudinaryId": video.public_id
`;
